import { cardRef, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { addGrowth, hasTrait, healUnit, isLiveOnBoard, plannedUnitId } from './plant-helpers.js';
/**
 * Бережный полив: прямое лечение своего Растения на 2. Если после применения
 * цель полностью здорова (включая уже полностью здоровую цель), она получает
 * 1 Рост. Розыгрыш — drag/tap заклинания прямо на карту Растения.
 */
export const GentleWateringCard = defineGameCard({
    id: 'gentle_watering',
    gameplay: {
        type: 'SPELL',
        cost: 1,
        planning: planningTargets([
            targetStep('target', unitTarget({
                side: 'ally',
                cardinality: { min: 1, max: 1 },
                where: ({ unit }) => unit.traits.includes('PLANT'),
            })),
        ]),
    },
    presentation: {
        name: 'Бережный полив',
        description: 'Ваше Растение восстанавливает 2 здоровья. Если после этого оно имеет полное здоровье, получает 1 Рост.',
        glyph: {
            colors: ['#10213A', '#D56B28', '#21487F', '#E89132', '#62551F'],
            rows: [
                '..111....111........',
                '.1...1..12221.......',
                '.1....11221221......',
                '.111111121.1221.....',
                '.123321421.12221....',
                '1222244421...3......',
                '1224442241...33.....',
                '1444422241...33.....',
                '144422241..333333...',
                '.1144411..33333331..',
                '...111....33333311..',
                '...........333311...',
                '.............11.....',
                '....................',
                '................5...',
                '...............5.5..',
                '............5.5.....',
                '.............55.....',
                '..............5.....',
                '............11111...',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve({
            source: 'card_effect',
            dependencies: [cardRef('plant_growth')],
            run: (ctx) => {
                const targetId = plannedUnitId(ctx, 'target');
                const target = targetId === undefined ? null : ctx.q.instance(targetId);
                if (ctx.self === undefined || !isLiveOnBoard(target)
                    || target.controllerId !== ctx.self.controllerId
                    || !hasTrait(ctx, target.id, 'PLANT'))
                    return;
                healUnit(ctx, target.id, 2, ctx.self.id);
                const stats = ctx.q.stats(target.id);
                if (stats.health >= stats.maxHealth) {
                    addGrowth(ctx, target.id, 1, 'watering');
                }
            },
        }),
    ],
    ui: {
        mechanics: ['growth'],
        planning: { steps: { target: { label: 'Выберите своё Растение' } } },
    },
});
//# sourceMappingURL=gentle_watering.js.map